module.exports = __webpack_public_path__ + "static/media/nima-wave01.c272979a.png";